import React from 'react';

import { Grid, LinearProgress, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  typographyDetail: {
    color: '#999999',
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: '0px',
    textAlign: 'center',
  },
}));

export default ({ progress }) => {
  const classes = useStyles();

  return (
    <div>
      <div style={{ marginBottom: '30px' }}>
        <Typography className={classes.typographyTitle}>Upload Video Report Failed</Typography>
      </div>

      <Grid container justify="center">
        <Typography className={classes.typographyLoadingText}>Upload Failed!</Typography>
      </Grid>

      <div style={{ marginBottom: '30px' }}>
        <LinearProgress value={progress} style={{ height: 5, width: '100%' }} variant="determinate" />
      </div>
    </div>
  );
};
